enum QuizTypes {
  Scoring = 'scoring',
  Personality = 'personality',
  Prediction = 'prediction',
  Poll = 'poll',
  Survey = 'survey',
  RankingPoll = 'rankingPoll',
  TeamSelector = 'teamSelector',
  BeatTheExpert = 'beatTheExpert',
  Streak = 'streak'
};

export default QuizTypes;
